<template>
  <div class="dcContainer" :class="{ 'is-collapsed': collapsed }">

    <div class="dcInner">
      <div class="d-flex align-center px-2 py-1">
        <v-btn icon small @click="collapsed = !collapsed" class="mr-2">
          <v-icon>{{ collapsed ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>

        <template v-if="!collapsed">
          <v-icon @click.native.passive="update">mdi-refresh</v-icon>
          <v-text-field
            outlined
            dense
            hide-details
            :value="search"
            @input="updateSearch"
            clearable
            label="Search"
            class="mx-2"
          ></v-text-field>
          <v-icon @click.native.passive="copy" class="ml-2 mr-4">mdi-content-copy</v-icon>
          <v-icon @click.native.passive="clear">mdi-delete-forever</v-icon>
        </template>

        <span v-else class="text-caption grey--text text--darken-2">
          Console Log ({{ linesCount }} lines)
        </span>
      </div>

      <div v-if="!collapsed" class="dcOutput">
        <div v-for="(line, index) of outputLines" :key="index" class="dcLine">
          {{ line }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { copyToClipboard } from "@/util/clipboard";

// Externer Speicher, um Reaktivitäts-Overhead bei massiven Logs zu vermeiden
let lines = [];

export default {
  name: "DebuggingConsole",
  data: () => ({
    search: '',
    outputLines: [],
    collapsed: true,
  }),
  computed: {
    linesCount() {
      return lines.length;
    }
  },
  mounted() {
    let self = this;
    try {
      let origConsole = console.log;
      console.log = function log() {
        self.outputConsole('' + arguments[0]);
        origConsole.apply(console, arguments);
      };
    } catch (e) {
      console.error('Error extending console: ' + e.message);
    }
  },
  methods: {
    copy() {
      let c = lines.join('\n');
      copyToClipboard(c, this);
    },
    clear() {
      lines = [];
      this.outputLines = [];
    },
    update() {
      const term = this.search ? this.search.toLowerCase() : '';
      this.outputLines = lines.filter(l =>
        !term || (l && l.toLowerCase().indexOf(term) !== -1)
      );
    },
    outputConsole(text) {
      lines.push(text);
      // Nur aktualisieren, wenn wir gerade nicht filtern oder die Konsole offen ist
      // if (!this.search && this.collapsed) {
      //   this.outputLines = [...lines];
      // }
    },
    updateSearch(v) {
      this.search = v;
      this.$nextTick(() => {
        this.update();
      });
    },
  }
}
</script>

<style scoped lang="scss">
.dcContainer {
  position: fixed;
  bottom: 100px;
  left: 0;
  height: 60vh;
  width: var(--layout-width);
  pointer-events: none;
  padding: 20px;
  z-index: 888;
  transition: all 0.3s ease-in-out;

  &.is-collapsed {
    height: 80px; // Reduzierte Höhe im zugeklappten Zustand
  }
}

.dcInner {
  pointer-events: all;
  background-color: rgba(white, 0.95);
  color: black;
  border: 1px solid #333;
  width: 100%;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
}

.dcOutput {
  font-size: 0.75em;
  font-family: monospace;
  overflow-y: scroll;
  height: calc(60vh - 100px);
  background: #f9f9f9;
}

.dcLine {
  border-bottom: 1px solid #eee;
  padding: 2px 8px;
  white-space: pre-wrap;
  word-break: break-all;

  &:hover {
    background: #f0f0f0;
  }
}

// Vuetify Hilfsklasse für Flexbox-Alignment, falls nicht global verfügbar
.align-center {
  align-items: center;
}
</style>
